import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';

import { accountsActions, accountsSelectors } from 'app-components/flux/accounts';

import DownshiftField from 'components/QuickenControls/DownshiftField';
import ReadOnlyField from 'components/Transactions/ReadOnlyField';

class AccountField extends PureComponent {
  constructor(props) {
    super(props);

    if (this.props.accountsLoadPending) {
      this.props.dispatchGetAccountsAction();
    }
  }

  render() {
    const {
      accounts,
      accountsLoadPending,
      initialAccount,
      initialAccountId,
      onSelected,
      dispatchGetAccountsAction,
      readOnly,
      className,
      doNotIncludeClosed,
      hideQBP = true,
      plain,
      InputProps,
      qbpAccountIds,
      ...otherProps
    } = this.props;
    let accountsSorted =
      this.props.accounts &&
      this.props.accounts.sort((item1, item2) =>
        item1.name.localeCompare(item2.name, undefined, { numeric: true, sensitivity: 'base' }),
      );

    if (this.props.doNotIncludeClosed) {
      accountsSorted = accountsSorted.filter((account) => !account.isClosed);
    }
    // allow excludeIds to be passed as a prop to exclude certain accounts from the list
    if (this.props.excludeIds && this.props.excludeIds.length > 0) {
      accountsSorted = accountsSorted.filter((account) => !this.props.excludeIds.includes(account.id));
    }
    if (hideQBP) {
      accountsSorted = accountsSorted.filter((account) => !qbpAccountIds?.includes(account.id));
    }

    let field;
    if (readOnly || (accounts.size === 1 && (initialAccount || initialAccountId))) {
      field = (
        <ReadOnlyField
          sharedcomponentid='AccountField'
          label={plain ? null : 'Account'}
          variant='filled'
          {...otherProps}
          value={initialAccount ? initialAccount.name : 'Unknown'}
          className={className}
          InputProps={InputProps}
        />
      );
    } else {
      field = (
        <DownshiftField
          sharedcomponentid='AccountField'
          dataLoading={accountsLoadPending}
          variant='filled'
          items={[...(accountsSorted && accountsSorted.values())]}
          initialItemSelected={initialAccount}
          onSelected={onSelected}
          textFieldProps={otherProps}
          InputProps={InputProps}
          itemToString={(account) => (account ? account.name : '')}
          itemKey={(account) => (account ? account.id : '')}
          indexId
          className={className}
          plain={plain}
          disabled={otherProps.disabled}
        />
      );
    }

    return field;
  }
}

AccountField.propTypes = {
  accounts: PropTypes.object,
  initialAccount: PropTypes.object,
  initialAccountId: PropTypes.string,
  onSelected: PropTypes.func,
  dispatchGetAccountsAction: PropTypes.func,
  accountsLoadPending: PropTypes.bool,
  fullWidth: PropTypes.bool,
  className: PropTypes.string,
  readOnly: PropTypes.bool,
  doNotIncludeClosed: PropTypes.bool,
  InputProps: PropTypes.object,
  plain: PropTypes.bool,
  hideQBP: PropTypes.bool,
  qbpAccountIds: PropTypes.object,
  excludeIds: PropTypes.arrayOf(PropTypes.string),
  disabled: PropTypes.bool,
};

function mapStateToProps(state, ownProps) {
  const accounts = ownProps.accounts || accountsSelectors.getTransactionAccounts(state);
  return {
    accounts,
    accountsLoadPending: accountsSelectors.getLoadPending(state),
    initialAccount: accounts && ownProps.initialAccountId ? accounts.get(ownProps.initialAccountId) : undefined,
    qbpAccountIds: accountsSelectors.getQBPAccountIds(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatchGetAccountsAction: () => dispatch(accountsActions.getAccounts()),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AccountField);
